/** smooth 스크롤 없이 Y 위치로 즉시 이동 (자동 정렬·탭 전환 시 모션 방지) */
export function scrollWindowToYInstant(top) {
  if (typeof window === 'undefined') return;
  const y = Math.max(0, top);
  const root = document.documentElement;
  const body = document.body;
  const prevRoot = root.style.scrollBehavior;
  const prevBody = body?.style.scrollBehavior;
  root.style.scrollBehavior = 'auto';
  if (body) body.style.scrollBehavior = 'auto';
  root.scrollTop = y;
  if (body) body.scrollTop = y;
  try {
    window.scrollTo({ top: y, left: 0, behavior: 'instant' });
  } catch {
    window.scrollTo(0, y);
  }
  root.style.scrollBehavior = prevRoot;
  if (body) body.style.scrollBehavior = prevBody;
}

export function scrollWindowToTopInstant() {
  scrollWindowToYInstant(0);
}

/** 요소가 실제 세로 스크롤 컨테이너일 때만 반환 */
export function getVerticalScrollContainer(el) {
  if (typeof window === 'undefined' || !el) return null;
  const { overflowY } = window.getComputedStyle(el);
  if (
    overflowY !== 'auto' &&
    overflowY !== 'scroll' &&
    overflowY !== 'overlay'
  ) {
    return null;
  }
  if (el.scrollHeight <= el.clientHeight + 1) return null;
  return el;
}

/**
 * anchor를 뷰포트 desiredTop(px)에 맞춤.
 * preferredScrollEl(예: .schedule_table_w) 우선, 없으면 #container.contents, 마지막 window.
 */
export function scrollAnchorToViewportTop(anchorEl, desiredTop, preferredScrollEl) {
  if (typeof window === 'undefined' || !anchorEl) return;
  const delta = anchorEl.getBoundingClientRect().top - desiredTop;
  if (Math.abs(delta) < 1) return;

  const scrollEl =
    getVerticalScrollContainer(preferredScrollEl) ||
    getVerticalScrollContainer(document.getElementById('container')) ||
    null;

  if (scrollEl) {
    scrollEl.scrollTop = Math.max(0, scrollEl.scrollTop + delta);
    return;
  }
  scrollWindowToYInstant(Math.max(0, window.scrollY + delta));
}
